/**
 * Check if the given enum has the given value mapped to a key.
 */
function isValidValue<T>(enumType: T, value: string | number): boolean {
  return Object.values(enumType).includes(value);
}

/**
 * Given an Enum and a possible backed value, return the value when it's a
 * valid enum value, else throw an Error.
 */
export function toEnum<T>(enumType: T, value: string | number): T[keyof T] {
  if (!isValidValue(enumType, value)) {
    throw new Error('Encountered value "' + String(value) + '" not mapped in target enum');
  }

  return value as T[keyof T];
}
